import React, { useState, useRef, useEffect } from "react";
import "remixicon/fonts/remixicon.css";
import { gsap } from "gsap";
import "./NavBar.css";
import mainLogo from "../../assets/mainLogo.png";

export const Navbar = () => {
  const [mobileDrawerOpen, setMobileDrawerOpen] = useState(false);
  const drawerRef = useRef(null);
  const linksRef = useRef([]);
  const animationRef = useRef(null);

  const toggleNavbar = () => {
    gsap.killTweensOf(drawerRef.current);

    if (mobileDrawerOpen) {
      gsap.to(drawerRef.current, {
        y: "-100%",
        opacity: 1,
        duration: 0.5,
        ease: "power2.in",
        onComplete: () => setMobileDrawerOpen(false),
      });
    } else {
      setMobileDrawerOpen(true);
    }
  };

  useEffect(() => {
    linksRef.current = [];

    if (mobileDrawerOpen) {
      const ctx = gsap.context(() => {
        const timeline = gsap.timeline();

        timeline.fromTo(
          drawerRef.current,
          { y: "-100%", opacity: 0 },
          { y: "0%", opacity: 1, duration: 0.5, ease: "power2.out" }
        );

        timeline.fromTo(
          linksRef.current,
          { y: -20, opacity: 0 },
          {
            y: 0,
            opacity: 1,
            duration: 0.3,
            stagger: 0.1,
            ease: "power2.out",
          },
          "-=0.2"
        );
      }, drawerRef);

      animationRef.current = ctx;
    } else if (animationRef.current) {
      animationRef.current.revert();
    }

    return () => animationRef.current?.revert();
  }, [mobileDrawerOpen]);

  const navItems = React.createElement(
    "ul",
    { className: "nav-items" },
    ["Brands", "Services", "Contact"].map((text) =>
      React.createElement(
        "li",
        { key: text },
        React.createElement(
          "a",
          {
            href:
              text === "Contact"
                ? "#contact"
                : text === "Brands"
                ? "#rent"
                : "#services",
          },
          text
        )
      )
    )
  );

  const drawerContent = mobileDrawerOpen
    ? React.createElement(
        "div",
        { className: "mobile-drawer", ref: drawerRef },
        React.createElement(
          "ul",
          null,
          [
            { text: "Brands", icon: "ri-roadster-line", href: "#rent" },
            { text: "Services", icon: "ri-shield-flash-line", href: "#services" },
            { text: "Contact", icon: "ri-mail-ai-line", href: "#contact" },
          ].map((item, index) =>
            React.createElement(
              "li",
              {
                key: item.text,
                ref: (el) => (linksRef.current[index] = el),
              },
              React.createElement(
                "a",
                { href: item.href },
                React.createElement("i", { className: item.icon }),
                " ",
                item.text
              )
            )
          )
        )
      )
    : null;

  const menuButton = React.createElement(
    "button",
    { onClick: toggleNavbar },
    mobileDrawerOpen
      ? React.createElement("i", { className: "ri-close-large-fill" })
      : React.createElement("i", { className: "ri-menu-3-fill" })
  );

  return React.createElement(
    "nav",
    { className: "navbar" },
    React.createElement(
      "div",
      { className: "container" },
      React.createElement(
        "div",
        { className: "navbar-content" },
        React.createElement(
          "div",
          { className: "text-container" },
          React.createElement(
            "a",
            { href: "/" },
            React.createElement("img", {
              src: mainLogo,
              alt: "Motatec Asia Logo",
              className: "logo-image",
            })
          )
        ),
        navItems,
        React.createElement(
          "div",
          { className: "mobile-menu" },
          menuButton
        )
      ),
      drawerContent
    )
  );
};
